import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import {SlideToggle} from 'react-slide-toggle';
import SideNav, {Nav, NavText} from 'react-sidenav';
import Button from '../../../../components/Button';

import './MapButtons.css';

@inject("appStore")
@observer
class MapButtons extends Component {

    toMapPos = (viewport) => {
        this.props.appStore.setMapViewport({
            center: {
                lat: viewport.center[0],
                lng: viewport.center[1]
            },
            zoom: viewport.zoom
        });
        //this.props.appStore.map.element.setView(campusLoc.center, campusLoc.zoom);
    };

    zoomAction = (idx) => {
        let element = this.props.appStore.appConfig.map.zoomLocations[idx];
        if (this.props.appStore.isMobile) {
            this.props.appStore.toggleMBIconClick();
        }
        this.toMapPos({center: [element.viewport.center.lat, element.viewport.center.lng], zoom: element.viewport.zoom});
    };

    mobileIconClicked = () => {
        this.props.appStore.toggleMBIconClick();
    };

    changeBGColor = () => {
        if (this.props.appStore.isMBIconClicked) {
            return {backgroundColor: '#bfbfbf'};
        } else {
            return {};
        }
    };

    getInnerSideNav = () => {
        return (
            <div className="innerSideNav">
                <div className="zoom-to"><i className="far fa-compass"/><p>Zoom to Location</p></div>
                <SideNav highlightColor='#3a3a3a' highlightBgColor='#bfbfbf' hoverBgColor='#eae6e6'
                         defaultSelected='main_campus'
                         onItemSelection={(id) => {
                             this.zoomAction(id);
                         }}>
                    {this.props.appStore.appConfig.map.zoomLocations.map((element, index) => (
                        <Nav key={index} id={index}>
                            <NavText>{element.defaultName}</NavText>
                        </Nav>
                    ))}
                </SideNav>
            </div>);
    };

    render() {
        if (this.props.appStore.isMobile) {
            return (
                <div className="MapButtonsM">
                    <div className="MBIcon">
                        <Button className='compassBtn' onClick={this.mobileIconClicked}
                                style={this.changeBGColor()}>
                            <i className="far fa-compass" aria-hidden="true"></i>
                        </Button>
                    </div>
                    {this.props.appStore.isMBIconClicked && this.getInnerSideNav()}
                </div>
            );
        } else {
            return (
                <div className="MapButtons">
                    {this.getInnerSideNav()}
                </div>
            );
        }

    }
}

export default MapButtons;


// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/MapButtons/index.js